import { useReducer, useEffect, MutableRefObject } from 'react';
// 方法
import { IBaseEdiTableContext } from '../context';
// 常量
import { MainSubEdiTableDispatchType, IMainSubEdiTablePayload } from '../interface';
import { FormInstance } from 'antd/lib/form';

export interface IDetailPageAction {
  type: MainSubEdiTableDispatchType;
  payload: IMainSubEdiTablePayload;
}

// Action
function EdiTableContextAction(
  state: IBaseEdiTableContext,
  action: IDetailPageAction,
): IBaseEdiTableContext {
  const oldDataSource = state.dataSource || [];
  const {
    dataSource,
    form,
    forms,
    flagIndex,
    addItem,
    isEmpty,
    record,
    updateDataSource,
    mainKey,
    addChildrenItem,
  } = action.payload;
  switch (action.type) {
    case 'init':
      if (forms && (!dataSource || dataSource.length === 0)) forms.current = [];
      if (
        (!oldDataSource || !oldDataSource.length) &&
        (!dataSource || !dataSource.length)
      ) {
        return {
          ...state,
          forms,
        };
      }
      return {
        ...state,
        forms,
        dataSource: dataSource?.map((item, index) => {
          const { children, ...restItem } = item;
          return {
            ...restItem,
            key: index,
            children: children?.map?.((v: any, k: number) => ({ ...v, key: k, })),
          };
        }),
      };
    case 'addForm':
      if (!form || record === undefined) return state;
      if (state.forms && state.forms.current) {
        const {parentKey, childrenKey} = record;
        if (!state.forms.current[parentKey]) state.forms.current[parentKey] = [];
        state.forms.current[parentKey][childrenKey] = form;
      }
      return state;
    case 'deleteForm':
      if (record === undefined) return state;
      if (state.forms && state.forms.current) {
        const {parentKey, childrenKey} = record;
        if (state.forms.current[parentKey]?.[childrenKey]) {
          state.forms.current[parentKey][childrenKey] = undefined;
        }
      }
      return state;
    case 'addRow':
      let key = flagIndex || 0;
      if (isEmpty) {
        return {
          ...state,
          dataSource
        };
      }
      return {
        ...state,
        dataSource: [
          ...(isEmpty ? [] : oldDataSource),
          ...(Array.isArray(addItem) ? addItem.map((v, k) => ({...v, key: key + k})) : [{...addItem, key: key}])
        ],
      };
    case 'addChildren':
      return {
        ...state,
        dataSource: oldDataSource.map(item => {
          if (item.key === Number(mainKey)) {
            const { children, ...restItem } = item;
            const lastKey = children?.[children.length - 1]?.key || 0;
            return {
              ...restItem,
              children: [
                ...children,
                ...(Array.isArray(addChildrenItem) ? addChildrenItem : [addChildrenItem || {}]).map((v, k) => ({...v, key: lastKey + (k + 1)}))
              ],
            }
          }
          return item;
        }),
      };
    case 'deleteRow':
      const {parentKey, childrenKey} = record;
      const findDataSource = oldDataSource.find(v => v.key === parentKey);
      if (findDataSource) {
        const { children } =  findDataSource;
        if (Array.isArray(children) && children.length > 1) {
          return {
            ...state,
            dataSource: oldDataSource.map(item => {
              if (item.key === parentKey) {
                return {
                  ...item,
                  children: children.filter((_, k) => k !== childrenKey),
                };
              }
              return item;
            }),
          };
        }
        return {
          ...state,
          dataSource: oldDataSource.filter(v => v.key !== parentKey),
        };
      }
      return state;
    case 'changeDataSource':
      return {
        ...state,
        dataSource: updateDataSource,
      };
    default:
      return state;
  }
}

// 初始数据
const initEdiTableContext: IBaseEdiTableContext = {};

// EdiTableContext
function useMainSubEdiTableContext(
  flagIndex: MutableRefObject<number>,
  dataSource?: any[],
  forms?: MutableRefObject<FormInstance[][]>,
) {
  const [EdiTableContext, dispatch] = useReducer(
    EdiTableContextAction,
    initEdiTableContext,
  );
  useEffect(() => {
    flagIndex.current = dataSource?.length || 0;
    dispatch({ type: 'init', payload: { dataSource, forms } });
  }, [dataSource]);
  function dispatchEdiTable(
    type: MainSubEdiTableDispatchType,
    payload: IMainSubEdiTablePayload = {},
  ) {
    const {
      addItem,
      form,
      isEmpty,
      updateDataSource,
      record,
      mainKey,
      addChildrenItem,
    } = payload;
    switch (type) {
      case 'addRow':
        const num = flagIndex.current;
        flagIndex.current = Array.isArray(addItem)
          ? num + addItem.length
          : num + 1;
        dispatch({ type, payload: { addItem, flagIndex: num, isEmpty } });
        break;
      case 'addChildren':
        dispatch({ type, payload: { mainKey, addChildrenItem, },});
        break;
      case 'deleteRow':
        dispatch({ type, payload: { record } });
        break;
      case 'addForm':
        dispatch({ type, payload: { form, record } });
        break;
      case 'deleteForm':
        dispatch({ type, payload: { record } });
        break;
      case 'changeDataSource':
        dispatch({ type, payload: { updateDataSource } });
        break;
    }
  }
  return {
    ...EdiTableContext,
    dispatchEdiTable,
  };
}

export default useMainSubEdiTableContext;
